import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticatedUEN, getUENUser } from './utils';

const PrivateRoute = ({ element, acess }) => {
    if (!isAuthenticatedUEN()) {
        return <Navigate to="/login" replace />;
    }

    if (acess == null) return element;

    const user = getUENUser();
    const role = user?.tipo || user?.role;
    return acess.includes(role) ? element : <Navigate to="/" replace />;
};

export default PrivateRoute;
